<template>
  <section
    class="my-8 md:mb-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-0 shadow-black shadow-xl divide-y-2 divide-white max-w-[1400px]"
  >
    <RallyLogoDownload />
    <div class="py-8 mt-8 flex flex-col gap-4">
      <h1 class="text-white text-2xl md:text-3xl font-russo">
        CROSS COUNTRY RALLY ROADBOOK SPECIFICATION
      </h1>
      <GuideDownloadCta />
      <h2 class="text-white font-russo text-[20px] md:text-[24px]">
        Built to the FIA Spec
      </h2>
      <p class="font-arial text-[#A9A9A9] text-[15px] md:text-[17px] text-left">
        Start with File &gt; New Cross Country FIA Dakar for the FIA layout: a
        wider tulip box and MODIF and NEW NOTE markers. It&#8217;s available to
        every user. Set each control&#8217;s open and validation radius in its
        properties and see it on the map. Print with the FIA/FIM blue track,
        Dakar-style waypoint numbers and the FIA lexicon pages added to your PDF.
        The same radii go out in the OpenRally GPX for tracking systems. Already
        have a roadbook in another format? Roadbook &gt; Change Roadbook Format
        converts it.
      </p>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/capture_decran_2022-01-04_152150-qbqkj0ewprrgk9dg09kcpjm678csb49tsxcu9m5pfy.webp" type="image/webp" />
        <img width="400" height="155"
        decoding="async"
        src="/images/fim-fia-roadbook-specs-rules/capture_decran_2022-01-04_152150-qbqkj0ewprrgk9dg09kcpjm678csb49tsxcu9m5pfy.png"
        title="capture_decran_2022-01-04_152150"
        alt="capture_decran_2022-01-04_152150"
        loading="lazy"
        class="flex m-auto"
        />
      </picture>
      <h2
        class="font-helvetica text-[22px] text-[#FF0000] hover:underline font-black"
      >
        <a
          href="https://www.fia.com/system/files/documents/260623_2026_cross-country_rally_sporting_regulations.pdf"
          target="_blank"
          rel="noopener"
        >
          2026 FIA Cross-Country Rally Sporting Regulations
        </a>
      </h2>
      <h2 class="text-white font-arial text-[17px] font-semibold">
        Roadbook Info Starts on Page 104
      </h2>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/2023-FIA-Rally-Icons-A.webp" type="image/webp" />
        <img
        decoding="async"
        fetchpriority="high"
        width="755"
        height="1051"
        src="/images/fim-fia-roadbook-specs-rules/2023-FIA-Rally-Icons-A.png"
        class="flex m-auto"
        alt="2023 FIA rally roadbook navigation icons chart"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/2023-FIA-Rally-Icons.webp" type="image/webp" />
        <img
        decoding="async"
        width="745"
        height="1059"
        src="/images/fim-fia-roadbook-specs-rules/2023-FIA-Rally-Icons.png"
        class="flex m-auto"
        alt="2023 FIA rally roadbook navigation icons"
        />
      </picture>
      <h2
        class="font-arial text-[17px] font-bold text-[#FF0000] hover:underline"
      >
        <a href="https://youtu.be/WvP9anc0nnc">
          Video Explaining FIA Navigation Waypoints &#8211; Click Here
        </a>
      </h2>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/CC-Waypoint-Chart-768x432.webp" type="image/webp" />
        <img
        decoding="async"
        width="768"
        height="432"
        src="/images/fim-fia-roadbook-specs-rules/CC-Waypoint-Chart-768x432.png"
        class="flex m-auto"
        alt="FIA cross-country rally waypoint types chart"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/2023 FIM waypoint penalties.webp" type="image/webp" />
        <img
        decoding="async"
        width="745"
        height="1059"
        src="/images/fim-fia-roadbook-specs-rules/2023 FIM waypoint penalties.png"
        class="flex m-auto"
        alt="2023 FIM waypoint validation penalties chart"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/waypoint-radius-1.webp" type="image/webp" />
        <img
          decoding="async"
          width="745"
          height="1059"
          src="/images/fim-fia-roadbook-specs-rules/waypoint-radius-1.jpg"
          class="flex m-auto"
          alt="FIA cross-country waypoint validation radius diagram"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/waypoint-radius-2.webp" type="image/webp" />
        <img
          decoding="async"
          width="745"
          height="1059"
          src="/images/fim-fia-roadbook-specs-rules/waypoint-radius-2.jpg"
          class="flex m-auto"
          alt="FIA cross-country waypoint validation radius diagram"
        />
      </picture>
      <h2
        class="font-arial text-[17px] font-bold text-[#FF0000] hover:underline"
      >
        <a href="https://youtu.be/WvP9anc0nnc?si=-oDNRyWxrngMax_a">
          Video Explaining Waypoint Types &#8211; Click Here
        </a>
      </h2>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Signs.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="733"
        height="909"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Signs.png"
        class="flex m-auto"
        alt="FIA cross-country rally control signs"
        />
      </picture>
      <h2 class="font-helvetica text-[22px] text-[#999999] font-semibold">
        FIA Cross Country Roadbook Specifications
      </h2>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="731"
        height="1027"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-2.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="733"
        height="969"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-2.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 2"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-3.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="735"
        height="975"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-3.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 3"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-4.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="727"
        height="971"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-4.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 4"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-5.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="735"
        height="745"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-5.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 5"
        />
      </picture>
      <picture class="contents">
        <source srcset="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-6.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="731"
        height="961"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-6.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 6"
        />
      </picture><img
        decoding="async"
        loading="lazy"
        width="735"
        height="343"
        src="/images/fim-fia-roadbook-specs-rules/FIA-Cross-Country-Control-Roadbook-Spec-7.png"
        class="flex m-auto"
        alt="FIA cross-country roadbook control specification page 7"
      />
    </div>
    <GuideDownloadCta />
  </section>
  <section class="my-8 mx-auto max-w-[1400px]">
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload />
  </section>
  <RelatedGuides
    :links="[
        { to: '/how-to-create-a-cross-country', text: 'How to Create a Cross Country Roadbook' },
        { to: '/fia-roadbook-specs-rules', text: 'FIA Road Rally Roadbook Specs' },
        { to: '/rally-tulip-diagrams', text: 'Rally Tulip Diagrams' },
        { to: '/rally-roadbook', text: 'What Is a Rally Roadbook?' },
      ]"
  />
</template>

<script>
import FeaturesBanner from './FeaturesBanner.vue';
import RelatedGuides from './RelatedGuides.vue';
import GuideDownloadCta from './GuideDownloadCta.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';

export default {
  name: 'CrossCountryFIACSpecsRules',
  components: {
    GuideDownloadCta,
    FeaturesBanner,
    RelatedGuides,
    RallyLogoDownload,
    PartnersSmall,
  },
};
</script>

<style scoped></style>
